<template>
  <v-container fluid>
   <div v-if="authenticated">
    <v-form v-model="valid" @submit="storeData()">
        <v-layout align-start wrap justify-start>
            <v-flex xs12>
                <KilnSelect complabel="Firing of"></KilnSelect>
            </v-flex>
            <v-flex xs12 md4>
                <v-text-field
                    v-model="firing.name"
                    :rules="nameRules"
                    :counter="15"
                    label="Firing name"
                    required
                ></v-text-field>
            </v-flex><span class="dArrow"></span>
            <v-flex xs12 md4>
                <v-text-field
                    v-model="firing.description"
                    :rules="descriptionRules"
                    :counter="30"
                    label="Firing description"
                    required
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-btn icon @click="storeData()"><v-icon>save</v-icon></v-btn>
            </v-flex>
            <v-snackbar v-model="snackbar" :bottom="y === 'bottom'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="timeout" :top="y === 'top'" :vertical="mode === 'vertical'" color='warning'>
                {{ text }}
            <v-btn color="black" flat @click="snackbar=false" round>Close</v-btn>
            </v-snackbar>
        </v-layout>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import axios from "axios"
import { mapState, mapGetters } from 'vuex';
import KilnSelect from '../components/KilnSelectComponent'

  export default {
    data() {
        return {
                firing: {
                "kilnId": 0,
                "userId": 0,
                "name": "",
                "description": "",
                "status": "STARTED"
            },
            ok: false,
            snackbar: false,
            y: 'top',
            x: 'left',
            mode: '',
            timeout: 5000,
            text: '',
            urlData: "/thermocouple-services/tc/control/",
            valid: false,
            nameRules: [
                v => !!v || 'Name is required',
                v => v.length <= 15 || 'Name must be less than 10 characters'
            ],
            description: '',
            descriptionRules: [
                v => !!v || 'Description is required',
                v => v.length <= 30 || 'Description must be less than 30 characters'
            ]
        }
    },
    components: {
        KilnSelect
    },
    methods: {
        ...mapGetters([
            'getLoggedInUser',
            'getSelectedLocation',
            'getSelectedKiln',
            'getAuthToken'
        ]),
        storeData() {
            if ( this.getSelectedLocation().name === 'Select' ) {
                this.text = 'Select a location first'
                this.snackbar = true;
            } else if ( this.getSelectedKiln().name === 'Select' ) {
                this.text = 'Select a kiln first'
                this.snackbar = true;
            }  else {
                this.firing.kilnId = this.getSelectedKiln().id;
                this.firing.userId = this.getLoggedInUser().id;
                var url = this.secureHost + this.urlData + this.getLoggedInUser().accountId + "/" + this.getSelectedLocation().name + "/" + this.getSelectedKiln().name + "/start";
                axios({ method: "POST", "url": url, "data": this.firing, "headers": { "content-type": "application/json", "Accept": "application/json", "Authorization": this.getAuthToken() } }).then(result => {
                        this.ok = true;
                    }).catch(error => {
                        this.text = 'Error starting firing'
                        this.snackbar = true;
                    });
            }
            console.log( this.firing )
        }
    },
    computed: {
        ...mapState([
            'authenticated',
            'secureHost'
        ])
    }
  }
</script>

<style scoped>
.dArrow {
    min-width: 20px;
    font-size: 16px;
    vertical-align: middle
}
</style>